/**
 * Format a numeric amount with thousand separators.
 * Uses the browser's locale for appropriate separator (e.g., 1,000 or 1.000).
 *
 * @param {string|number} amount - The amount to format
 * @param {string} [locale] - Optional locale (defaults to browser locale)
 * @returns {string} Formatted amount (e.g., "4,500" or "12,350.75")
 */
export const formatAmount = (amount, locale) => {
  if (amount === null || amount === undefined || amount === '') {
    return '';
  }

  const num = Number(amount);
  if (isNaN(num)) {
    return String(amount);
  }

  return num.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};
